// extracted by mini-css-extract-plugin
export var cardHeader = "_fs-1";
export var contentCard = "_fs-0";
export var headerActions = "_fs-3";
export var reorderHandle = "_fs-5";
export var titleArea = "_fs-2";
export var titleAreaWithHandle = "_fs-4";